import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper.jsx";
import MobileSliderPagesHeader from "../components/MobileSliderPagesHeader.jsx";

function SlideMobilePosition() {
    return <MobileSliderPagesWrapper backgroundColor="var(--color-base-secondary)">
        <MobileSliderPagesHeader goBack>
            <h4>MobilePosition</h4>
        </MobileSliderPagesHeader>
    </MobileSliderPagesWrapper>
}

export default SlideMobilePosition;
